import { useCallback } from 'react';
import { api } from 'aws-blocks';
import { useAuthContext } from '../contexts/AuthContext';
import { useSnackBarContext } from '../contexts/SnackBarContext';

/** Reads displayPieceValues from the user profile (Dynamo SETTINGS#), default true. */
export default function useDisplayPieceValues() {
  const { currentUser, userData, queryUserData, openLoginModal } =
    useAuthContext();
  const { addSnackBar } = useSnackBarContext();
  const displayPieceValues =
    typeof userData?.displayPieceValues === 'boolean'
      ? userData.displayPieceValues
      : true;

  const setDisplayPieceValues = useCallback(
    async (value: boolean) => {
      if (!currentUser) {
        openLoginModal();
        return;
      }
      try {
        await api.updatePlayerSettings({ displayPieceValues: value });
        await queryUserData();
      } catch (err) {
        addSnackBar({
          title: 'ERROR',
          message: err instanceof Error ? err.message : String(err),
          variant: 'danger',
          timeout: 2500,
        });
      }
    },
    [currentUser, openLoginModal, queryUserData, addSnackBar]
  );

  return { displayPieceValues, setDisplayPieceValues };
}
